module.exports = __webpack_public_path__ + "img/background-main-kvota.0638e578.svg";